import { ForwardedRef, forwardRef, PropsWithChildren } from 'react';
import { matchLI } from '@rogu/adt';
import { Button, ButtonProps, useBreakpointValue } from '@chakra-ui/react';

type ButtonSize = 'lg' | 'md' | 'sm' | 'xs';

interface ResponsiveButtonProps extends Omit<ButtonProps, 'size'> {
  size?: ButtonSize;
}

const ResponsiveButton = forwardRef(
  (
    { children, ...props }: PropsWithChildren<ResponsiveButtonProps>,
    ref: ForwardedRef<HTMLButtonElement>,
  ) => {
    const breakpointSize = matchLI(props.size || 'md')({
      lg: () => ({ base: 'md', md: 'lg' }),
      md: () => ({ base: 'sm', md: 'md' }),
      sm: () => ({ base: 'sm' }),
      xs: () => ({ base: 'xs' }),
    });
    const size = useBreakpointValue(breakpointSize);

    return (
      <Button
        ref={ref}
        fontWeight="normal"
        fontSize="sm"
        borderRadius="full"
        {...props}
        size={size || 'md'}
      >
        {children}
      </Button>
    );
  },
);

const PrimaryButton = forwardRef(
  (
    { children, ...props }: PropsWithChildren<ResponsiveButtonProps>,
    ref: ForwardedRef<HTMLButtonElement>,
  ) => {
    return (
      <ResponsiveButton
        ref={ref}
        color="white"
        background="primary.tealGradient"
        _hover={{ background: 'primary.tealGradientHover' }}
        {...props}
      >
        {children}
      </ResponsiveButton>
    );
  },
);

export { ResponsiveButton, PrimaryButton };
